module.exports = __webpack_public_path__ + "static/img/21.00fd91b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/21.png
// module id = Std2
// module chunks = 0